module.exports = __webpack_public_path__ + "093896dce6fc763920631a12a8cb498f.woff";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/proxima-nova/2E6388_1_0.woff
// module id = 532
// module chunks = 0